import Reveal, { SectionHead } from "@/components/Reveal";

const STEPS = [
  { n: "01", title: "Chiamata", text: "Ci spieghi brevemente il guasto: bastano trenta secondi." },
  { n: "02", title: "Tecnico assegnato", text: "Individuiamo l'unità mobile più vicina alla tua zona." },
  { n: "03", title: "Arrivo e preventivo", text: "Valutazione sul posto e prezzo chiaro prima di iniziare." },
  { n: "04", title: "Risoluzione immediata", text: "Riparazione effettuata al momento, con ricambi a bordo." },
];

export default function HowItWorks() {
  return (
    <section id="come-funziona" className="border-y border-line bg-ink/30 py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <SectionHead
          kicker="Semplice e veloce"
          title="Come funziona l'intervento, in 4 passi"
        />

        <ol className="mt-14 grid gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((step, i) => (
            <Reveal key={step.n} delay={0.09 * i}>
              <li className="group relative border-l border-line pl-6 transition-colors duration-300 hover:border-volt lg:pl-7">
                <span
                  aria-hidden="true"
                  className="absolute -left-[1px] top-0 h-0 w-[2px] bg-volt transition-all duration-700 group-hover:h-full"
                />
                <span className="font-mono text-sm font-bold tracking-[0.2em] text-volt">
                  {step.n}
                </span>
                <h3 className="mt-3 font-display text-lg font-bold text-white sm:text-xl">
                  {step.title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-slate-400">{step.text}</p>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}
